<template>
  <div class="footer">
    <div class="common">
      <div class="footext">
        <p>客服电话：021-39586681 | 09:00-18:00（星期一～星期五，节假日除外）</p>
        <p class="addressline">微信客服：小盖（gasgoo2019）</p>
        <p>
          Copyright © 2007 - 2020 Gasgoo. All Rights Reserved. 盖世汽车 版权所有
          增值电信业务经营许可证 沪B2-2007118
          <a
            href="http://beian.miit.gov.cn/publish/query/indexFirst.action"
            target="_blank"
            rel="nofollow"
            style="color: white; padding-left: 10px"
            >沪ICP备07023350号</a
          >
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011402009699"
            target="_blank"
            style="color: white; padding-left: 10px"
            >沪公网安备 31011402009699号</a
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app-footer",
};
</script>
